import { PAGE } from '@/constants/page.js'
export default {
  computed: {
    livechatChannelOptions() {
      const selectedBot = this.$store.state.livechat.bot
      return this.handleGetChannelOptions(selectedBot)
    }
  },
  methods: {
    handleGetChannelOptions(bot) {
      const selectedBot = bot || this.$store.state.selectedBot
      let channels = []
      if (
        selectedBot &&
        !['universalutilities', 'hafele', 'scgallrent', 'nvbb', 'scgworkplace'].includes(
          selectedBot.theme
        ) &&
        !['102052945584054', '106855151601601', '100707492390105'].includes(selectedBot.pageid)
      ) {
        channels.push('fb')
      }
      if (
        selectedBot &&
        !['universalutilities'].includes(selectedBot.theme) &&
        !['dtac-gaming'].includes(selectedBot.type) &&
        (selectedBot.line_modular_botid ||
          selectedBot.line_access_token ||
          this.$store.state.nestlePages.some((page) => page.pageid === selectedBot.pageid))
      ) {
        channels.push('line')
      }
      if (selectedBot) {
        const com7page = this.$store.state.com7pages.map((page) => page.pageid)
        if (
          selectedBot.instagram_business_account &&
          !com7page.includes(selectedBot.pageid) &&
          !['prudential'].includes(selectedBot.type)
        ) {
          channels.push('ig')
        }
        switch (selectedBot.type) {
          case 'gpf':
            channels.push('webchat', 'app')
            break
          case 'trueid':
          case 'mtc':
          case 'demo':
            channels.push('webchat')
            break
          case 'sprc':
            channels.push('ms_team', 'webchat')
            break
          default:
            break
        }

        if (
          !channels.includes('webchat') &&
          (PAGE.DDPROPERTY.includes(selectedBot.pageid) || selectedBot.unlock_webchat)
        ) {
          channels.push('webchat')
        }
      }
      if (selectedBot && selectedBot.whatsapp_status && selectedBot.unlock_whatsapp) {
        channels.push('whatsapp')
      }
      const channelOptions = this.$store.state.socialChannelOptions.filter((el) =>
        channels.includes(el.value)
      )

      return channelOptions
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/livechat/LivechatSocialChannelMixin.js